import React, { useState, useEffect } from "react";
import "./Notifications.css";
import Container from "react-bootstrap/Container";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  GetNotifications,
  GetNotificationUnreadCount,
  MarkNotificationRead,
} from "../../apis/NotificationAPI";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

export default function Notifications() {
  const {user} = useSelector((state) => state.auth);
  const [notificationList, setNotificationList] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  async function GetUserNotifications() {
    var result = await GetNotifications();
    var data = result.data;
    setNotificationList(data);
  }

  async function GetNotificationCount() {
    var result = await GetNotificationUnreadCount();
    setUnreadCount(result.data);
  }

  async function MarkNotification() {
    var result = await MarkNotificationRead();
    console.log(result);
  }

  useEffect(() => {
    GetUserNotifications();
    GetNotificationCount();
    MarkNotification();
  }, []);

  window.addEventListener("notification", () => {
    GetUserNotifications();
    GetNotificationCount();
    MarkNotification();
  });
  return (
    <>
      <Container className="mb-5">
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title">
              <h2>Notifications {unreadCount > 0 ? `(${unreadCount})` : ""}</h2>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter"></div>
          </Col>
        </Row>
        <Row className="">
          <Col lg={12}>
            <Card className="notifications-card">
              <ul className="notifications-list">
                {notificationList.map((item) =>
                  item.order_status_name === "Completed" ? (
                    <li className={item.view_id === 0 ? "unread" : ""}>
                      <p>
                        Order number{" "}
                        <Link
                          to={`/Customer/OrdersDetails?id=${item.order_id}`}
                        >
                          {item.order_id}
                        </Link>{" "}
                        for {item.applicant_name} was marked complete.{" "}
                        <Link
                          to={`/Report?type=view&id=${item.order_report_mapping_id}`}
                          target="_blank"
                          className={
                            item.template_name != null && item.template_name.includes("Pdf Reports")
                              ? "no-display"
                              : ""
                          }
                        >
                          View Reports
                        </Link>
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : item.order_status_name === "In Progress" ? (
                    <li className={item.view_id === 0 ? "unread" : ""}>
                      <p>
                        Work started on Order number{" "}
                        <Link
                          to={`/Customer/OrdersDetails?id=${item.order_id}`}
                        >
                          {item.order_id}
                        </Link>{" "}
                        for {item.applicant_name}.
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : item.order_status_name === "Preliminary" ? (
                    <li className={item.view_id === 0 ? "unread" : ""}>
                      <p>
                        Preliminary report generated of Order number{" "}
                        <Link
                          to={`/Customer/OrdersDetails?id=${item.order_id}`}
                        >
                          {item.order_id}
                        </Link>{" "}
                        for {item.applicant_name}.{" "}
                        <Link
                          to={`/Report?type=view&id=${item.order_report_mapping_id}`}
                          target="_blank"
                          className={
                            item.template_name != null && item.template_name.includes("Pdf Reports")
                              ? "no-display"
                              : ""
                          }
                        >
                          View Reports
                        </Link>
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : item.order_status_name === "Received" ? (
                    <li className={item.view_id === 0 ? "unread" : ""}>
                      <p>
                        Form number{" "}
                        <Link
                          to={`/Form?token=view&id=${item.form_template_id}&applicationid=${item.order_id}`}
                          target="_blank"
                        >
                          {item.form_number}
                        </Link>{" "}
                        has been received from {item.applicant_name}.{" "}
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : item.order_status_name === "Invoiced" ? (
                    <li className={item.view_id === 0 ? "unread" : ""}>
                      <p>
                        Order number{" "}
                        <Link
                          to={`/Customer/OrdersDetails?id=${item.order_id}`}
                        >
                          {item.order_id}
                        </Link>{" "}
                        has been invoiced.{" "}
                        <Link
                          to={`/Invoice?customerid=${
                            user.customerid
                          }&invoiceid=${item.invoice_id}`}
                          target="_blank"
                        >
                          View Invoice
                        </Link>
                      </p>
                      <span className="text-italic">
                        {dateFormat(
                          new Date(item.created_date + "z"),
                          "mmmm dd, yyyy hh:mmtt"
                        )}
                      </span>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
